import NewsFeed from '../assets/SideNavIcons/News_Feed.svg';
import Collaboration from '../assets/SideNavIcons/Collaboration.svg';
import Resources from '../assets/SideNavIcons/Resources.svg';
import Certification from '../assets/SideNavIcons/Certification.svg';
import Tasks from '../assets/SideNavIcons/Task.svg';
import Network from '../assets/SideNavIcons/Network.svg';
import MediaDrive from '../assets/SideNavIcons/Media_Drive.svg';
import Meetings from '../assets/SideNavIcons/Meeting.svg';
import Affiliate from '../assets/SideNavIcons/Affiliate_Programme.svg';
import Deals from '../assets/SideNavIcons/Deals.svg';
import BusinessProspect from '../assets/SideNavIcons/Business_Prospects.svg';
import ProductWarranty from '../assets/SideNavIcons/Product_Warrenty.svg';
import Contracts from '../assets/SideNavIcons/Contracts-1.svg';
import SupportTicket from '../assets/SideNavIcons/Support&Ticketing.svg';
import Employees from '../assets/SideNavIcons/Employees.svg';
import Recognition from '../assets/SideNavIcons/Recognition.svg';
import Trainingwebinar from '../assets/SideNavIcons/trainingwebinar.svg';

export const SideMenuRoutes = {
	1  : { linkPath: '/news', icon: NewsFeed, title: 'news feed' },
	// 2  : { linkPath: '/contacts', icon: Collaboration, title: 'collaboration' },
	2  : { linkPath: '/collaboration', icon: Collaboration, title: 'collaboration' },
	3  : { linkPath: '/resource', icon: Resources, title: 'resources' },
	4  : { linkPath: '/certification', icon: Certification, title: 'certification' },
	5  : { linkPath: '/tasks', icon: Tasks, title: 'tasks' },
	6  : { linkPath: '/connections', icon: Network, title: 'network' },
	7  : { linkPath: '/drive/folder', icon: MediaDrive, title: 'media drive' },
	8  : { linkPath: '/meetings', icon: Meetings, title: 'meetings' },
	9  : { linkPath: '/webinars', icon: Trainingwebinar, title: 'webinar' },
	10 : { linkPath: '/affiliate', icon: Affiliate, title: 'affiliate programme' },
	11 : { linkPath: '/deal', icon: Deals, title: 'deal registration' },
	12 : { linkPath: '/businessprospects', icon: BusinessProspect, title: 'business prospects' },
	13 : { linkPath: '/productWarranty', icon: ProductWarranty, title: 'product warranty' },
	14 : { linkPath: '/contractManagement', icon: Contracts, title: 'Contracts' },
	15 : { linkPath: '/supportTicketing', icon: SupportTicket, title: 'support & ticket' },
	16 : { linkPath: '/employees', icon: Employees, title: 'employees' },
	17 : { linkPath: '/businessSettings/content', icon: Resources, title: 'content management' },
	18 : { linkPath: '/recognition', icon: Recognition, title: 'recoginition' },
	19 : { linkPath: '/taskmangement', icon: Recognition, title: 'Task Mangement' }
};

export const routesForAccessCheck =
	[
		// '/collaboration',
		// '/resourcemanagement',
		// '/certification',
		// '/tasks',
		'/connections',
		'/drive',
		'/meetings',
		'/webinars',
		'/affiliate',
		'/deal',
		'/businessprospects',
		'/productWarranty',
		'/contractManagement'
		// '/supportTicketing',
		// '/employees',
		// '/recognition',
		// '/taskmangement'
	];
